<script lang="ts">
	import Button from '../../Button.svelte';
	export let options = [];
	export let abcdeGroups = [];

	function onIncomeClick(ageGrp: string, event: Event) {
		event.preventDefault();
		if (abcdeGroups.some((item) => item === ageGrp)) {
			abcdeGroups = abcdeGroups.filter((item) => item !== ageGrp);
		} else {
			const newabcdeGroups = [...abcdeGroups, ageGrp];
			abcdeGroups = options.filter((item) => newabcdeGroups.includes(item));
		}
	}

	function onAnyClick(event: Event) {
		event.preventDefault();
		abcdeGroups = options.length === abcdeGroups.length ? [] : options;
	}
</script>

<Button
	margin
	variant={options.length === abcdeGroups.length || abcdeGroups.length === 0
		? 'raised'
		: 'outlined'}
	on:click={onAnyClick}
>
	any
</Button>
{#each options as ageGrp}
	<Button
		margin
		variant={abcdeGroups.some((x) => x === ageGrp) ? 'raised' : 'outlined'}
		on:click={(e) => onIncomeClick(ageGrp, e)}
	>
		{ageGrp}
	</Button>
{/each}
